import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { needsInitialSetup } from '../services/setupService';
import { useAuth } from '../contexts/AuthContext';

interface InitialSetupCheckerProps {
  children: React.ReactNode;
}

/**
 * مكون للتحقق من حالة النظام
 * يتحقق من حالة النظام قبل عرض المحتوى
 */
const InitialSetupChecker: React.FC<InitialSetupCheckerProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();
  const [checkingSetup, setCheckingSetup] = useState(true);

  useEffect(() => {
    const checkSetup = async () => {
      try {
        // تجاهل الفحص للصفحات التي لا تحتاج إعداد
        const exemptPaths = ['/setup', '/login', '/register'];
        if (exemptPaths.some(path => location.pathname.startsWith(path))) {
          setCheckingSetup(false);
          return;
        }

        console.log('فحص حالة النظام...');
        // تم تعطيل فحص النظام - System check disabled
        console.log('تم تجاهل فحص النظام');
        
        // const needsSetup = await needsInitialSetup();
        // if (needsSetup && !currentUser) {
        //   console.log('النظام يحتاج إلى إعداد أولي، التوجيه إلى صفحة الإعداد');
        //   navigate('/setup', { replace: true });
        //   return;
        // }
        
        setCheckingSetup(false);
      } catch (error) {
        console.error('خطأ في فحص حالة النظام:', error);
        setCheckingSetup(false);
      }
    };

    checkSetup();
  }, [navigate, location.pathname, currentUser]);

  if (checkingSetup) {
    // شاشة تحميل بسيطة
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5'
      }}>
        <div style={{
          textAlign: 'center',
          color: '#666'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e3e3e3',
            borderTop: '4px solid #667eea',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }} />
          <p>جاري التحميل...</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return <>{children}</>;
};

export default InitialSetupChecker;
